import { FaqDto, getFaqPrivateEndpoint } from 'cpnl-common';
import { createCmsContentSlice } from 'cms-integration';

const { reducer, fetchContent } = createCmsContentSlice<FaqDto>({
    contentName: 'faq',
    contentEndpoint: getFaqPrivateEndpoint,
});

export default reducer;
export const fetchFaq = fetchContent;
